<div data-testid="company-form-dialog-container" class="company-form-dialog p-1">
  <div class="space-y-4">
    <!-- Company Code -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "organizational.company.form.fields.code" | translate }}
        <span class="text-red-500">*</span>
      </label>
      <input
        data-testid="company-form-dialog-code-input"
        type="text"
        pInputText
        class="w-full"
        [placeholder]="
          'organizational.company.form.placeholders.code' | translate
        "
        [(ngModel)]="formData.code"
        [disabled]="isViewMode"
        [class.border-red-300]="showErrors() && !formData.code"
      />
      @if (showErrors() && !formData.code) {
        <p class="text-red-500 text-xs mt-1">
          {{
            "organizational.company.messages.error.code_required" | translate
          }}
        </p>
      }
      @if (isOverMaxLength(formData.code)) {
        <p class="text-red-500 text-xs mt-1">
          {{ 'common.validation.maxlength' | translate: maxLengthParams('organizational.company.form.fields.code', 255) }}
        </p>
      }
    </div>

    <!-- Company Name -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "organizational.company.form.fields.name" | translate }}
        <span class="text-red-500">*</span>
      </label>
      <input
        data-testid="company-form-dialog-name-input"
        type="text"
        pInputText
        class="w-full"
        [placeholder]="
          'organizational.company.form.placeholders.name' | translate
        "
        [(ngModel)]="formData.name"
        [disabled]="isViewMode"
        [class.border-red-300]="showErrors() && !formData.name"
      />
      @if (showErrors() && !formData.name) {
        <p class="text-red-500 text-xs mt-1">
          {{
            "organizational.company.messages.error.name_required" | translate
          }}
        </p>
      }
      @if (isOverMaxLength(formData.name)) {
        <p class="text-red-500 text-xs mt-1">
          {{ 'common.validation.maxlength' | translate: maxLengthParams('organizational.company.form.fields.name', 255) }}
        </p>
      }
    </div>

    <!-- Registered Business Name -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{
          "organizational.company.form.fields.registered_business_name"
            | translate
        }}
        <span class="text-red-500">*</span>
      </label>
      <input
        data-testid="company-form-dialog-registered-business-name-input"
        type="text"
        pInputText
        class="w-full"
        [placeholder]="
          'organizational.company.form.placeholders.registered_business_name'
            | translate
        "
        [(ngModel)]="formData.registeredBusinessName"
        [disabled]="isViewMode"
        [class.border-red-300]="
          showErrors() && !formData.registeredBusinessName
        "
      />
      @if (showErrors() && !formData.registeredBusinessName) {
        <p class="text-red-500 text-xs mt-1">
          {{
            "organizational.company.messages.error.registered_business_name_required"
              | translate
          }}
        </p>
      }
      @if (isOverMaxLength(formData.registeredBusinessName)) {
        <p class="text-red-500 text-xs mt-1">
          {{ 'common.validation.maxlength' | translate: maxLengthParams('organizational.company.form.fields.registered_business_name', 255) }}
        </p>
      }
    </div>

    <!-- Legal Person -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "organizational.company.form.fields.legal_person" | translate }}
      </label>
      <input
        data-testid="company-form-dialog-legal-person-input"
        type="text"
        pInputText
        class="w-full"
        [placeholder]="
          'organizational.company.form.placeholders.legal_person' | translate
        "
        [(ngModel)]="formData.legalPerson"
        [disabled]="isViewMode"
      />
      @if (isOverMaxLength(formData.legalPerson)) {
        <p class="text-red-500 text-xs mt-1">
          {{ 'common.validation.maxlength' | translate: maxLengthParams('organizational.company.form.fields.legal_person', 255) }}
        </p>
      }
    </div>

    <!-- Business License -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "organizational.company.form.fields.business_license" | translate }}
      </label>
      <input
        data-testid="company-form-dialog-business-license-input"
        type="text"
        pInputText
        class="w-full"
        [placeholder]="
          'organizational.company.form.placeholders.business_license'
            | translate
        "
        [(ngModel)]="formData.businessLicense"
        [disabled]="isViewMode"
      />
      @if (isOverMaxLength(formData.businessLicense)) {
        <p class="text-red-500 text-xs mt-1">
          {{ 'common.validation.maxlength' | translate: maxLengthParams('organizational.company.form.fields.business_license', 255) }}
        </p>
      }
    </div>

    <!-- Status -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "organizational.company.form.fields.status" | translate }}
      </label>
      <p-select
        data-testid="company-form-dialog-status-select"
        [options]="statusOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="formData.status"
        [disabled]="isViewMode"
        class="w-full"
      ></p-select>
    </div>
  </div>

  <!-- Actions -->
  <div class="flex justify-end gap-3 mt-8 pt-4 border-t border-gray-200">
    <app-button
      [testId]="'company-form-dialog-cancel-btn'"
      [label]="'common.actions.cancel' | translate"
      type="secondary"
      [outlined]="true"
      (emitOnClick)="onCancel()"
    ></app-button>

    @if (!isViewMode) {
      <app-button
        [testId]="'company-form-dialog-confirm-btn'"
        [label]="
          isEditMode
            ? ('common.actions.save' | translate)
            : ('common.actions.create' | translate)
        "
        type="info"
        [loading]="submitting()"
        [disabled]="submitting()"
        (emitOnClick)="onConfirm()"
      ></app-button>
    }
  </div>

  @if (serverError()) {
    <div
      class="bg-red-50 border border-red-200 rounded p-3 text-sm text-red-600 mt-2"
    >
      {{ serverError()?.message }}
    </div>
  }
</div>
